export default {
  ERROR: 'annotationAudioError'
};
